import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { REQUIRED_RULES } from "@src/frontend/utils";
import type { ScriptResourceModel } from "@src/generated/prisma/models"
import { Alert, Button, Flex, Form, Input, type FormInstance } from "antd"
import { useCallback } from "react";

export type FormData = Omit<ScriptResourceModel, 'logto_uid' | 'create_at'>

interface Props {
  form: FormInstance<FormData>;
  onSubmit?: (data: FormData) => void;
}

export const ResourceEditForm = (props: Props) => {
  const { form, onSubmit } = props;
  const handleSave = useCallback(async () => {
    const values = await form.validateFields();
    onSubmit?.(values);
  }, [form, onSubmit]);
  return (
    <Flex vertical gap={12}>
      <Form form={form} layout="vertical">
        <Form.Item hidden name='id'><Input /></Form.Item>
        <Form.Item label='资源名称' name='name' rules={[REQUIRED_RULES]}>
          <Input />
        </Form.Item>
        <Form.List name={'data'}>
          {(fields, { add, remove }) => {
            return (
              <Flex vertical>
                {fields.map(({ name, key }, i) => (
                  <Flex key={key} gap={8}>
                    <Flex flex={1} gap={8} align="center">
                      <Form.Item style={{ width: '100%' }} rules={[REQUIRED_RULES]} label='键名' name={[name, 'key']}>
                        <Input allowClear />
                      </Form.Item>
                    </Flex>
                    <Flex flex={1}>
                      <Form.Item style={{ width: '100%' }} rules={[REQUIRED_RULES]} label='值' name={[name, 'value']}>
                        <Input allowClear />
                      </Form.Item>
                    </Flex>
                    <Flex flex={0}>
                      <MinusCircleOutlined onClick={() => remove(i)} style={{ marginTop: 4, color: 'red' }} />
                    </Flex>
                  </Flex>
                ))}
                <Button type="dashed" onClick={() => add({})} icon={<PlusOutlined />}>添加</Button>
              </Flex>
            );
          }}
        </Form.List>
      </Form>
      <Alert style={{ marginTop: 12 }} closable title='注意：键名重复的值将会被最后设置的覆盖。' />
      <Button block onClick={handleSave} type="primary">保存</Button>
    </Flex>
  );
}